<template>
  <v-app>

    <v-content>
      <v-container>
        <v-row>
          <v-col
            cols="12"
            md="10"
            offset-md="1"
            offset-lg="3"
            lg="6">
            <v-card class="elevation-0">

              <v-card-text>
                <v-row
                >
                  <v-img
                    :src="require('@/assets/logo-atschool.png')"
                    alt="atschool Logo"
                    class="ma-0"
                    max-width="150"/>
                </v-row>
              </v-card-text>

              <v-alert
                v-if="lastUserExpiry!==false"
                text
                outlined
                color="deep-orange"
                dense>
                Last session expiry: {{ lastUserExpiry }}
              </v-alert>

              <v-card-text>
                <span class="title font-weight-bold">Log in to your child's @school</span>
              </v-card-text>

              <v-card-text>
                <v-form
                  ref="form"
                  v-model="valid"
                  autocomplete="off"
                  lazy-validation>
                  <v-alert
                    :value="error"
                    color="error"
                    icon="warning"
                    dismissible
                    @input="clearErrorMsg"
                    transition="fade-transition">
                    {{ errorMsg }}
                  </v-alert>
                  <v-text-field
                    v-model="userId"
                    :rules="userIdRules"
                    prepend-icon="person"
                    :append-icon="showUserId ? 'visibility_off' : 'visibility'"
                    type="text"
                    @click:append="showUserId = !showUserId"
                    id="username"
                    label="User ID"
                    autocomplete="username"
                    :class="{ 'hide-input': !showUserId }"
                    required />
                  <v-text-field
                    v-model="userPassword"
                    :rules="userPasswordRules"
                    @keyup.enter="login()"
                    prepend-icon="lock"
                    :append-icon="showPassword ? 'visibility_off' : 'visibility'"
                    :type="showPassword ? 'text' : 'password'"
                    @click:append="showPassword = !showPassword"
                    id="password"
                    label="Password"
                    autocomplete="current-password"
                    :class="{ 'hide-input': !showPassword }"
                    required />
                </v-form>
              </v-card-text>
              <v-card-text class="pt-0">
                <a
                  href="https://www.atschool.co.nz/forgot_password.php"
                  style="text-decoration: none"
                  target="_blank">
                  <v-icon
                    small
                    class="mr-1">mdi-lock-reset</v-icon>
                  Reset Password
                </a>
                <a
                  href="https://etap.co.nz/Docs/AppPrivacy.html"
                  style="text-decoration: none; margin-left: 20px"
                  target="_blank">
                  <v-icon
                    small
                    class="mr-1">mdi-shield-check</v-icon>
                  Privacy Policy
                </a>
              </v-card-text>
              <v-container fluid>
                <v-checkbox v-model="agreedToTerms">
                  <template v-slot:label>
                    <div>
                      I have read and agreed to the
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <a
                            target="_blank"
                            href="https://etap.co.nz/Docs/Etap_Application_Licence_June2023.pdf"
                            class="terms-link"
                            v-on="on"
                            @click.stop
                          >
                            Terms and Conditions *
                          </a>
                        </template>
                        Opens in new window
                      </v-tooltip>
                    </div>
                  </template>
                </v-checkbox>
              </v-container>
              <v-card-actions>
                <v-btn
                  @click="login()"
                  color="primary"
                  block
                  :disabled="!agreedToTerms"
                >
                  <v-progress-circular
                    v-if="authStatus == 'loading'"
                    indeterminate
                    color="white"
                    class=""
                    :size="20"
                    :width="3"/>
                  <span
                    :class="[{'white--text': valid }]"
                    v-else>
                    Log in
                  </span>
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-content>

  </v-app>
</template>

<script>
import { mapState } from 'vuex'
export default {
  data: () => ({
    valid: false,
    userId: '',
    userIdRules: [
      v => !!v || 'User ID is required'
    ],
    userPassword: '',
    userPasswordRules: [
      v => !!v || 'Password is required'
    ],
    showUserId: false,
    showPassword: false,
    lastUserExpiry: '',
    agreedToTerms: false
  }),

  computed: {
    ...mapState({
      authStatus: 'status',
      errorMsg: 'loginErrorMsg'
    }),
    error: function () {
      if (this.authStatus === 'error') {
        return true
      }
      return false
    },
    idString: function () {
      var loginId = localStorage.getItem('loginId')

      if (loginId !== null) {
        return loginId
      } else {
        return false
      }
    },

    lastExp: function () {
      var userE = localStorage.getItem('expiryLastLog')

      if (userE !== null) {
        return userE
      } else {
        return false
      }
    }
  },

  created: function () {
    this.clearErrorMsg()
    if (typeof this.$route.query.token !== 'undefined') { // Handle token login from etap
      let token = this.$route.query.token
      this.$store.dispatch('logout')
        .then(() => { return this.$store.dispatch('tokenLogin', token) })
        .then(() => this.$router.replace('/home'))
        .catch(err => {
          if (this.error) { // If error already showing, make it fade in and out to show error again.
            this.$store.commit('reset_status')
            setTimeout(() => {
              this.$store.commit('auth_error')
              this.$store.commit('error_message', err.response.data.error)
            }, 250)
          } else {
            this.$store.commit('auth_error')
            this.$store.commit('error_message', err.response.data.error)
          }
        })
    }

    if (this.$store.getters.isLoggedIn) {
      this.$router.replace('/home')
    }

    if (this.lastExp !== '') {
      this.lastUserExpiry = this.lastExp
    } else {
      this.lastUserExpiry = false
    }

    let schoolid = this.$route.params.schoolid
    let pupilid = this.$route.params.pupilid
    let cgid = this.$route.params.cgid
    if (typeof schoolid !== 'undefined' && typeof pupilid !== 'undefined' && typeof cgid !== 'undefined') {
      this.userId = schoolid + '/' + pupilid + '/' + cgid
    } else {
      this.userId = this.idString || ''
    }
  },

  methods: {
    clearErrorMsg: function () {
      this.$store.commit('clear_auth_error')
    },

    login: function () {
      if (this.$refs.form.validate()) {
        let userId = this.userId
        let userPassword = this.userPassword
        this.$store.dispatch('login', { userId, userPassword })
          .then(() => {
            sessionStorage.setItem('justLoggedIn', 'true')
            sessionStorage.removeItem('locked')
            this.$store.dispatch('checkUnreadCounts')
            this.$router.replace('/home')
            this.$router.go(0)
          })
          .catch(err => {
            if (this.error) { // If error already showing, make it fade in and out to show error again.
              this.$store.commit('reset_status')
              setTimeout(() => {
                this.$store.commit('auth_error')
                this.$store.commit('error_message', err.response.data.error)
              }, 250)
            } else {
              this.$store.commit('auth_error')
              this.$store.commit('error_message', err.response.data.error)
            }
          })
      }
    }
  }
}
</script>

<style>
@font-face {
  /* font-family: 'password'; */
  /* font-style: normal; */
  /* font-weight: 400; */
  /* src: url('~@/assets/password.ttf'); */
  /* src: url('~@/assets/dotsfont.woff2'); */

  font-family: "Password";
  src:
    url("~@/assets/password.woff2") format("woff2"), /* Modern Browsers */
    url("~@/assets/password.woff") format("woff"), /* Modern Browsers */
    url("~@/assets/password.ttf") format("truetype"), /* Safari, Android, iOS */
    url("~@/assets/password.otf") format("opentype"), /* Open Type Font */
    url("~@/assets/password.eot") format("embedded-opentype"), /* IE9 Compat Modes */
    url("~@/assets/password.eot?#iefix") format("embedded-opentype"), /* IE6-IE8 */
    url("~@/assets/password.svg") format("svg"); /* Legacy iOS */
  font-weight: normal;
  font-style: normal;
}

div.hide-input > .v-input__control > .v-input__slot > .v-text-field__slot > input {
  font-family: 'password';
}

.terms-link {
  text-decoration: none;
}

.terms-link:hover {
  color: red;
}
</style>
